import Vue from 'vue/dist/vue.min.js';
import store from './store';

const FooterUnits = () => {

    let footerUnits = document.querySelector('.footer__units-container');

    let FooterUnitsConstructor = () => {
        Vue.component('footer-unit-toggler', {
            data: function() {
                return {
                    selectedUnit: store.state.units,
                    selectedUnitText: null
                }
            },
            computed: {
                units: function() {
                    return store.state.units;
                },
                taggingMeta: function() {
                    return JSON.stringify({
                        "type": "cta",
                        "category": "Preference",
                        "action": "Unit of measure",
                        "label": this.selectedUnitText
                    })
                }
            },
            watch: {
                units: function() {
                    this.selectedUnit = this.units;
                    this.setTags();
                }
            },
            methods: {
                handleChange(e) {
                    store.commit('setUnits', e.target.value);
                    this.setWidth();
                },
                setTags() {
                    let select = this.$refs.select;
                    // console.log(select);
                    let selectedText = select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : null;
                    this.selectedUnitText = selectedText;
                },
                initTags() {
                    let text = this.$el.querySelector(`option[value="${store.state.units}"]`) ? this.$el.querySelector(`option[value="${store.state.units}"]`).innerText : null;
                    this.selectedUnitText = text;
                },
                setWidth() {
                    let select = this.$refs.select;
                    let selectedText = select.options[select.selectedIndex].text;
                    let width = `${(selectedText.length / 2) + 2}em`; //assumes each chara is ~.5em width, +2em buffer
                    select.style.maxWidth = width;
                }
            },
            mounted() {
                this.$nextTick(() => {
                    this.initTags();
                    this.setWidth();
                })
                this.setTags();
            }
        });

        Vue.component('footer-lang-toggler', {
            data: function() {
                return {
                    selectedLang: store.state.currentLang,
                    selectedLangText: null,
                    languages: [],
                    store: store
                }
            },
            computed: {
                taggingMeta: function() {
                    return JSON.stringify({
                        "type": "cta",
                        "category": "Preference",
                        "action": "Language",
                        "label": this.selectedLangText
                    })
                }
            },
            watch: {
               
            },
            methods: {
                handleChange(e) {
                    let url = e.target.value;
                    let el = this.$refs.select;
                    let lang = el.options[el.selectedIndex].dataset.lang;
                    if (lang) {
                        document.cookie = `selectedLanguage=${lang}; path=/; max-age=31536000;`;
                    }
                    this.setWidth();
                    window.location.href = url;
                },
                setTags() {
                    let text = this.$el.querySelector(`option[value="${store.state.currentLang}"]`) ? this.$el.querySelector(`option[value="${store.state.currentLang}"]`).innerText : null;
                    this.selectedLangText = text;
                },
                setWidth() {
                    let select = this.$refs.select;
                    let selectedText = select.options[select.selectedIndex].text;
                    let width = `${(selectedText.length / 2) + 2}em`;//assumes each chara is ~.5em width, +2em buffer
                    select.style.maxWidth = width;
                }

            },
            mounted() {
                this.setTags();
                this.$nextTick(() => {
                    this.setWidth();
                });
            }
        });

        new Vue({
            el: `.footer__units-container`,
        }).$mount(`.footer__units-container`, true);
    }

    if (footerUnits) {
        FooterUnitsConstructor();
    }

}

export default FooterUnits;